import scoreToRating from "./scoreToRating";

export {
	scoreToRating,
};
